module.exports = __webpack_public_path__ + "static/media/shoot.8717955f.gif";